import CheckboxWithInputField from './CheckboxWithInputField.component';

export default CheckboxWithInputField;